import React from "react";
import { useLocation } from "react-router-dom";

const Footer = (props) => {
  const location = useLocation();

  if (location.pathname.includes("/webcontents/")) return null;

    return (
      <div style={{width:"100%", padding: "100px 0px", backgroundColor: "#282A35", color:'#FFFFFF'}}>
        <div style={{display: 'flex', justifyContent: 'center', marginBottom: '20px'}}>
          <span>© {(new Date()).getFullYear()} Copyright by Feng Wang</span>
        </div>           
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <span>Email: globefeng@yahoo.com</span>
        </div> 

          <script type="text/javascript">
          var sc_project=12959063; 
          var sc_invisible=1; 
          var sc_security="b04ed336"; 
          </script>
          <script type="text/javascript"
          src="https://www.statcounter.com/counter/counter.js"
          async></script>
          <noscript><div class="statcounter"><a title="Web Analytics"
          href="https://statcounter.com/" target="_blank" rel="noreferrer"><img
          class="statcounter"
          src="https://c.statcounter.com/12959063/0/b04ed336/1/"
          alt="Web Analytics"
          referrerPolicy="no-referrer-when-downgrade" /></a></div></noscript>

      </div>
    );
}

export default Footer;

